/**
 * The seasonal decorations, in priority order (the first one whose window
 * holds the date wins, so holidays come before the seasons around them),
 * with their default MM-DD windows. Easter has none: it moves with Easter
 * Sunday. Must match $seasons in extend.php, which registers the settings.
 */

const SEASONS = [{
  key: 'halloween',
  start: '10-20',
  end: '11-01'
}, {
  key: 'christmas',
  start: '12-01',
  end: '12-26'
}, {
  key: 'newyear',
  start: '12-27',
  end: '01-02'
}, {
  key: 'easter'
}, {
  key: 'spring',
  start: '03-01',
  end: '05-31'
}, {
  key: 'summer',
  start: '06-01',
  end: '08-31'
}, {
  key: 'autumn',
  start: '09-01',
  end: '11-30'
}, {
  key: 'winter',
  start: '12-01',
  end: '02-29'
}];
export default SEASONS;

/** Easter Sunday of a year (the Gregorian "anonymous" algorithm). */
export function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = (h + l - 7 * m + 114) % 31 + 1;
  return new Date(year, month - 1, day);
}
flarum.reg.add('bimmerdock-theme', 'common/seasons', SEASONS);